import { ReuseModal } from "../../ReuseModal";
import React, { ReactNode, useEffect, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { Dropdown } from "../../dropdown/Dropdown";
import { HubSpotIcon, SalesForceIcon } from "../../../images";
import { CRMData, CRMListItem } from "../../../../types/apiTypes";
import { DataSources } from "./DataSource";
import { CrmTypes } from "../../../../types";
import { capitalizeFirstLetter } from "../../../../utils/capitalizeFirstLetter";

const UPLOAD_OPTIONS = ["All Data", "Choose from List"];
const CRM_OPTIONS = [
  { value: "hubspot", icon: <HubSpotIcon /> },
  { value: "salesforce", icon: <SalesForceIcon /> },
];

type Props = {
  openModal: CrmTypes;
  onClose: () => void;
  setDataSource: (data: CRMData) => void;
  crmList: CRMListItem[];
  setOpenModal: (data: CrmTypes) => void;
  isLoading: boolean;
};

export const SyncCRMModal = ({
  openModal,
  onClose,
  setDataSource,
  crmList,
  setOpenModal,
  isLoading,
}: Props) => {
  const [selectedData, setSelectedData] = useState<string>("");
  const [uploadOption, setUploadOption] = useState<string>(UPLOAD_OPTIONS[1]);
  const [crmOption, setCrmOption] = useState<
    | {
        value: string;
        icon?: ReactNode;
      }
    | undefined
  >(CRM_OPTIONS.find(({ value }) => value === openModal));

  useEffect(() => {
    if (crmOption?.value !== openModal)
      setOpenModal((crmOption?.value as CrmTypes) || openModal);
  }, [crmOption]);

  useEffect(() => {
    if (uploadOption === UPLOAD_OPTIONS[0]) setSelectedData("");
  }, [uploadOption]);

  const syncHandler = () => {
    setDataSource({ crm: openModal, list_id: selectedData || undefined });
    onClose();
  };

  return (
    <ReuseModal
      isOpen={!!openModal}
      onClose={onClose}
      title="Sync CRM"
      onSubmit={syncHandler}
      maxWidth="540px"
      submitBtnColor="#1C3C6C"
      submitBtnText="Sync"
      isLoading={isLoading}
      isDisabled={isLoading}
    >
      <Dropdown
        label=""
        selectedItem={{
          ...crmOption,
          value: capitalizeFirstLetter(crmOption?.value || ""),
        }}
        onChange={(item) =>
          setCrmOption({ ...item, value: item.value.toLowerCase() })
        }
        items={CRM_OPTIONS.map((item) => ({
          ...item,
          value: capitalizeFirstLetter(item.value),
        }))}
        placeholder=""
      />
      <Stack gap="16px">
        <Typography
          component="span"
          variant="subtitle1"
          color="custom.textDarkBlue"
          fontWeight={500}
        >
          Which data-set would you like to import?
        </Typography>
        <FormControl sx={{ padding: "0 12px", alignItems: "flex-start" }}>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={uploadOption}
            value={uploadOption}
            name="radio-buttons-group"
            onChange={(e, el) => setUploadOption(el)}
          >
            {UPLOAD_OPTIONS.map((option) => (
              <FormControlLabel
                key={option}
                value={option}
                control={<Radio />}
                label={option}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Stack>

      {uploadOption === UPLOAD_OPTIONS[1] &&
        (crmList.length === 0 ? (
          <Typography variant="subtitle1" color="#1F293299" align="center">
            You don't have any list
          </Typography>
        ) : (
          <DataSources crmList={crmList} setSelectedData={setSelectedData} />
        ))}
    </ReuseModal>
  );
};
